import React, { useState, useEffect } from "react";
import * as Fa from "react-icons/fa";
import { format, subDays } from "date-fns";
// import { GoAlertFill } from "react-icons/go";
import XLSX from "xlsx";
import { toast } from "react-toastify";
import storage from "../../../Services/Storage";
import {
    createAPIEndpointCreditMReports,
    EndpointCreditMReports,
} from "../../../Services/ReportsAll/CreditManagementReports";
import { Calendar } from "primereact/calendar";
import { MultiSelect } from "primereact/multiselect";
import { GetDateFormat } from "../../../Services/GlobalFunc/DateFormat";
// import { Link } from "react-router-dom";

const LedgerReport = () => {
    const date = subDays(new Date(), 7);
    const [fromDate, setFromDate] = useState(date);
    const [toDate, setToDate] = useState(new Date());
    const [loadingExcel, setLoadingExcel] = useState(false);
    const auth = storage.getLocal("user");
    const [ledgerReportAccNameData, setledgerReportAccNameData] = useState();
    const [selectedAccount, setSelectedAccount] = useState(null);

    const handleExportExcel = () => {
        if (selectedAccount == null) {
            toast.warn("Please Select Account", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        // ----------Revert validation as instructed by ashok da and raju da on 09/08/25---------
        // let daycount = Math.round(
        //     (toDate.getTime() - fromDate.getTime()) / (1000 * 3600 * 24)
        // );
        // if (daycount > 92) {
        //     toast.warning("Maximum 92 Days Selection is Allowed!", {
        //         position: toast.POSITION.TOP_CENTER,
        //         pauseOnFocusLoss: false,
        //         closeButton: false,
        //         autoClose: 2000,
        //     });
        //     return;
        // }
        const fDate = new Date(fromDate);
        const fromDateRange = format(fDate, "dd/MM/yyyy");
        const tDate = new Date(toDate);
        const toDateRange = format(tDate, "dd/MM/yyyy");

        let accids = selectedAccount
            .map((item) => `${item.MASK_ACCT_ID}`)
            .join(",");

        let uniqueNo = `LedgerReport${GetDateFormat()}`;
        setLoadingExcel(true);
        const payload = {
            CompId: auth.CompId,
            fromDate: fromDateRange,
            toDate: toDateRange,
            acctId: accids,
        };
        createAPIEndpointCreditMReports()
            .post(
                `${EndpointCreditMReports.ledgerReportDownloadData}`,
                JSON.stringify(payload),
                {
                    headers: { "Content-Type": "application/json" },
                }
            )
            .then((val) => {
                if (val.data.length > 0) {
                    var wb = XLSX.utils.book_new();
                    let MapData = val.data.map((val) => {
                        var dateString = val["Document Date"];
                        var newData = dateString.replace(/(\d+[/])(\d+[/])/, "$2$1");
                        var data = new Date(newData);
                        return {
                            ...val,
                            "Document Date": data,
                        };
                    });
                    var ws = XLSX.utils.json_to_sheet(MapData);
                    XLSX.utils.book_append_sheet(wb, ws, uniqueNo);
                    XLSX.writeFile(wb, `${uniqueNo}.xlsx`);
                } else {
                    toast.warning("No data found between these dates", {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    });
                }
                setLoadingExcel(false);
            })
            .catch((err) => {
                toast.error(`${err.response.data}`, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                setLoadingExcel(false);
            });
    };
    const getLedgerReportAccName = () => {
        setLoadingExcel(true);
        createAPIEndpointCreditMReports()
            .get(
                `${EndpointCreditMReports.ledgerReportAccName}?CompId=${auth.CompId}`
            )
            .then((val) => {
                if (val.data.length > 0) {
                    setledgerReportAccNameData(val.data);
                } else {
                    setledgerReportAccNameData([]);
                }
                setLoadingExcel(false);
            })
            .catch((err) => {
                console.log(err);
                setLoadingExcel(false);
            });
    };

    useEffect(() => {
        getLedgerReportAccName();
    }, []);

    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Ledger Report</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="float-end mb-2">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleExportExcel}
                                disabled={loadingExcel}
                            >
                                {loadingExcel ? "Loading..." : "Save As Excel"}{" "}
                                {loadingExcel ? (
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                ) : (
                                    <Fa.FaDownload className="ms-2" />
                                )}
                            </button>
                        </div>
                    </div>
                </div>

                {/* <section className="AlertBox mb-3">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="card">
                            <p className="mb-0 d-flex justify-content-center align-items-center">
                                <span><GoAlertFill className="icon" /></span>
                                <span>Ledger Report may have some issues. Please download <Link to="/reports/creditmanagementreports/StatementOfAccounts">Statement of Account Report</Link> for serving your purpose.</span>
                            </p>
                        </div>
                    </div>
                </section> */}

                <section className="sales-box">
                    <form>
                        <div className="row">
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <label className="form-label">From Date</label>
                                <Calendar
                                    onChange={(e) => {
                                        setFromDate(e.target.value);
                                    }}
                                    showIcon
                                    value={fromDate}
                                    min="2010-01-01"
                                    dateFormat="dd/mm/yy"
                                />
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <label className="form-label">To Date</label>
                                <Calendar
                                    value={toDate}
                                    onChange={(e) => setToDate(e.value)}
                                    showIcon
                                    min="2010-01-01"
                                    dateFormat="dd/mm/yy"
                                />
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <label className="form-label mb-2">Account</label>
                                <MultiSelect
                                    filter
                                    resetFilterOnHide
                                    multiple
                                    value={selectedAccount}
                                    onChange={(e) => setSelectedAccount(e.value)}
                                    options={ledgerReportAccNameData}
                                    optionLabel="ACCOUNT_NAME"
                                    placeholder="Select a Account"
                                />
                            </div>
                        </div>
                    </form>
                </section>
            </div>
        </>
    );
};

export default LedgerReport;
